import React, { useState, useContext, useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
	AppBar,
	Hidden,
	Toolbar,
	Typography,
	IconButton,
	Tooltip,
	Menu,
	MenuItem,
	Snackbar,
	SnackbarContent,
	LinearProgress,
	Badge,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
	Avatar,
	CircularProgress
} from "@material-ui/core";
import { NavLink } from "react-router-dom";

import MoreVertIcon from "@material-ui/icons/MoreVert";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";

import { UserContext } from "../../contexts/UserContext";
import { PageContext } from "../../contexts/PageContext";
import ConfirmDialog from "../general/ConfirmDialog";
import InfoDialog from "../general/InfoDialog";
// import DemoTour from "../general/DemoTour";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		zIndex: 20,
		color: "#fff",
		// [theme.breakpoints.up("lg")]: {
		// 	width: `calc(100% - ${drawerWidth}px)`,
		//   marginLeft: drawerWidth,
		// }
	},
	logo: {
		display: "flex",
		alignItems: "flex-end",
		width: 120,
		textDecoration: "none",
		marginTop: theme.spacing(1),
		"& img": {
			width: 80,
			height: "auto",
		},
		"& span": {
			fontSize: 14,
			fontWeight: 600,
			letterSpacing: 2,
			color: "#ddd",
			marginLeft: 10,
			marginBottom: 4
		}
	},
	menuButton: {
		marginRight: theme.spacing(2),
		color: "#fff",
	},
	title: {
		flexGrow: 1,
	},
	accountButton: {
		marginLeft: theme.spacing(3),
		color: "#fff",
	},
	accountMenuItem: {
		fontSize: "90%",
		textTransform: "uppercase",
	},
	accountMenuNavLink: {
		color: theme.palette.text.primary,
		textDecoration: "none"
	},
	infoMessageBarContent: {
		backgroundColor: theme.palette.secondary.dark,
		color: "#fff",
	},
	errorMessageBarContent: {
		backgroundColor: theme.palette.error.dark,
		whiteSpace: "pre-line"
	},
	snackbarIcon: {
		fontSize: 20,
		marginRight: theme.spacing(1),
		verticalAlign: -4,
	},
	loadingBar: {
		position: "absolute",
		left: 0,
		right: 0,
		top: 0,
	},
	close: {
		padding: theme.spacing(0.5),
	}
}));

export default function Header(props) {
	const theme = useTheme();
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = useState(null);
	const [anchorRunningJobs, setAnchorRunningJobs] = useState(null);
	// this variable only saves the current time to force rerender of the timer clocks in running jobs dropdown
	const [runningJobsTimer, setRunningJobsTimer] = useState(Date.now());
	const open = Boolean(anchorEl);
	const pageContext = useContext(PageContext);
	function handleMenu(event) {
		setAnchorEl(event.currentTarget);
	}

	function handleClose() {
		setAnchorEl(null);
	}

	const refreshJobsTimer = () => {
		if (anchorRunningJobs) {
			setRunningJobsTimer(Date.now());
			setTimeout(refreshJobsTimer, 1000);
		}
	}

	useEffect(() => {
		refreshJobsTimer();
	}, [anchorRunningJobs]);

	return (
		<React.Fragment>
			<AppBar
				position="fixed"
				className={classes.root}
				color="primary"
				elevation={0}
			>
				<Toolbar>
					<NavLink
						to="/"
						activeClassName="active"
						exact
						className={classes.logo}
					>
						<img src="/logo.png" /><span>CCM</span>
					</NavLink>
					<Typography variant="h6" className={classes.title}>
						{/* {pageContext.pageTitle} */}
					</Typography>
					<UserContext.Consumer>
						{({ user, logout }) => {
							return (
								<div>
									<Tooltip title={user.name ? user.name : ""}>
										<IconButton
											aria-controls="menu-appbar"
											aria-haspopup="true"
											onClick={handleMenu}

											className={classes.accountButton}
											size="small"
										>
											<AccountCircleIcon />
										</IconButton>
									</Tooltip>
									<Menu
										id="menu-appbar"
										anchorEl={anchorEl}
										anchorOrigin={{
											vertical: "top",
											horizontal: "right",
										}}
										keepMounted
										transformOrigin={{
											vertical: "top",
											horizontal: "right",
										}}
										open={open}
										onClose={handleClose}
									>

										<MenuItem
											className={classes.accountMenuItem}
										>
											<NavLink
												to="/profile/"
												className={classes.accountMenuNavLink}
												activeClassName="active"
												onClick={() => handleClose()}
											>
												Profil
											</NavLink>
										</MenuItem>
										{(user.role === "administrator" || user.role === "agent") &&
											<MenuItem
												className={classes.accountMenuItem}
											>
												<NavLink
													to="/benutzereinstellungen/"
													className={classes.accountMenuNavLink}
													activeClassName="active"
													onClick={() => handleClose()}
												>
													meine Einstellungen
												</NavLink>
											</MenuItem>
										}
										<MenuItem
											className={classes.accountMenuItem}
											onClick={() => {
												handleClose();
												logout();
											}}
										>
											abmelden
										</MenuItem>
									</Menu>
								</div>
							);
						}}
					</UserContext.Consumer>
					{pageContext.runningJobs && pageContext.runningJobs.length > 0 &&
						<>
							<Tooltip title={"laufende Prozesse anzeigen"}>
								<IconButton
									aria-controls="menu-appbar"
									aria-haspopup="true"
									onClick={(e) => { setAnchorRunningJobs(anchorRunningJobs ? null : e.currentTarget) }}
									className={classes.accountButton}
									size="small"
								>
									<Badge badgeContent={pageContext.runningJobs.length} color="secondary" overlap="rectangular">
										<CircularProgress color="secondary" size={24} />
									</Badge>
								</IconButton>
							</Tooltip>

							<Menu
								id="menu-runningjobs"
								anchorEl={anchorRunningJobs}
								transformOrigin={{
									vertical: "bottom",
									horizontal: "right",
								}}
								open={Boolean(anchorRunningJobs)}
								onClose={(e) => { setAnchorRunningJobs(null) }}
							>
								<List>
									{pageContext.runningJobs.map(job =>
										<ListItem key={job.key}>
											<ListItemAvatar>
												<Avatar>
													{job.icon}
												</Avatar>
											</ListItemAvatar>
											<ListItemText primary={job.title} secondary={job.subtitle + "\n... seit " + Math.floor((runningJobsTimer - job.startTime) / 60000) + "m " + (Math.floor((runningJobsTimer - job.startTime) / 1000) % 60) + "s"} />
										</ListItem>
									)}
								</List>
							</Menu>
						</>
					}
					<IconButton
						edge="end"
						className={classes.menuButton}
						color="inherit"
						aria-label="menu"
						onClick={() => props.setMenuOpen(!props.menuOpen)}
					>
						<MoreVertIcon />
					</IconButton>
				</Toolbar>
				{pageContext.isLoading && (
					<LinearProgress className={classes.loadingBar} />
				)}
			</AppBar>
			{pageContext.errorMessage && (
				<Snackbar
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "left",
					}}
					open={
						pageContext.errorMessage !== null && pageContext.errorMessage !== ""
					}
					onClose={() => {
						pageContext.setErrorMessage("");
					}}
				>
					<SnackbarContent
						className={classes.errorMessageBarContent}
						aria-describedby="client-snackbar"
						message={
							<span id="client-snackbar">
								<ErrorIcon className={classes.snackbarIcon} />
								{pageContext.errorMessage}
							</span>
						}
						action={
							<IconButton
								aria-label="close"
								color="inherit"
								className={classes.close}
								onClick={() => {
									pageContext.setErrorMessage("");
								}}
							>
								<CloseIcon />
							</IconButton>
						}
					/>
				</Snackbar>
			)}
			{pageContext.infoMessage && (
				<Snackbar
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "left",
					}}
					open={
						pageContext.infoMessage !== null && pageContext.infoMessage !== ""
					}
					autoHideDuration={6000}
					onClose={() => {
						pageContext.setInfoMessage("");
					}}
				>
					<SnackbarContent
						className={classes.infoMessageBarContent}
						aria-describedby="client-snackbar"
						message={
							<span id="client-snackbar">
								<InfoIcon className={classes.snackbarIcon} />
								{pageContext.infoMessage}
							</span>
						}
					/>
				</Snackbar>
			)}
			<ConfirmDialog {...pageContext.confirmDialog} />
			<InfoDialog {...pageContext.infoDialog} />
		</React.Fragment>
	);
}
